import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e } from "../../../../../core/maybe.js";
import { c as t, f as a } from "../../../../../chunks/vec2f32.js";
import { FADE_DURATION as i } from "../../vectorTiles/decluttering/config.js";
import { VTL_TEXTURE_BINDING_UNIT_SPRITES as r, VTL_TEXTURE_BINDING_UNIT_GLYPHS as s } from "../definitions.js";
import { WGLDrawPhase as n } from "../enums.js";
import { degToByte as o } from "../GeometryUtils.js";
import { u32to4Xu8 as l } from "../number.js";
import f from "./WGLBrush.js";
var c = 1 / 65536;

var p = /*#__PURE__*/function (_f) {
  _inherits(p, _f);

  var _super = _createSuper(p);

  function p() {
    var _this;

    _classCallCheck(this, p);

    _this = _super.apply(this, arguments), _this._iconProgramOptions = {
      id: !1,
      sdf: !1
    }, _this._sdfProgramOptions = {
      id: !1
    }, _this._spritesTextureSize = t();
    return _this;
  }

  _createClass(p, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "drawMany",
    value: function drawMany(e, t) {
      var a = e.drawPhase,
          i = e.styleLayerUID,
          r = e.styleLayer;
      var s;
      a === n.HITTEST && (s = l(i + 1)), this._drawIcons(e, r, t, s), this._drawText(e, r, t, s);
    }
  }, {
    key: "_drawIcons",
    value: function _drawIcons(t, a, s, l) {
      var f = t.context,
          c = t.displayLevel,
          _p = t.drawPhase,
          u = t.painter,
          m = t.spriteMosaic,
          g = t.state,
          y = t.styleLayerUID,
          d = a.iconMaterial,
          _ = u.vectorTilesMaterialManager;
      var h,
          M = !1;

      var _iterator = _createForOfIteratorHelper(s),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;

          if (_e.layerData.has(y) && (h = _e.layerData.get(y), h.iconPerPageElementsMap.size > 0)) {
            M = !0;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!M) return;
      var U = a.getPaintValue("icon-translate", c),
          P = a.getPaintValue("icon-translate-anchor", c);
      var x = a.getLayoutValue("icon-rotation-alignment", c);
      2 === x && (x = 0 === a.getLayoutValue("symbol-placement", c) ? 1 : 0);
      var v = 0 === x,
          T = a.getLayoutValue("icon-keep-upright", c) && v,
          E = h.isIconSDF,
          D = _p === n.HITTEST,
          V = this._iconProgramOptions;
      V.id = D, V.sdf = E;

      var S = _.getMaterialProgram(f, d, V);

      f.useProgram(S), S.setUniformMatrix3fv("u_displayViewMat3", 0 === x ? g.displayViewMat3 : g.displayMat3), S.setUniformMatrix3fv("u_displayMat3", 1 === P ? g.displayMat3 : g.displayViewMat3), S.setUniform2fv("u_iconTranslation", U), S.setUniform1f("u_depth", a.z), S.setUniform1f("u_mapRotation", o(g.rotation)), S.setUniform1f("u_keepUpright", T ? 1 : 0), S.setUniform1f("u_level", 10 * c), S.setUniform1i("u_texture", r), S.setUniform1f("u_fadeDuration", i / 1e3), D && S.setUniform4fv("u_id", l);
      var w = -1;

      var _iterator2 = _createForOfIteratorHelper(s),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _i = _step2.value;
          if (!_i.layerData.has(y)) continue;
          if (_i.key.level !== w && (w = _i.key.level, d.setDataUniforms(S, c, a, w, m)), h = _i.layerData.get(y), 0 === h.iconPerPageElementsMap.size) continue;
          h.prepareForRendering(f), h.updateOpacityInfo();
          var _r = h.iconVertexArrayObject;

          if (!e(_r)) {
            f.bindVAO(_r), S.setUniformMatrix3fv("u_dvsMat3", _i.transforms.dvs), S.setUniform1f("u_time", (performance.now() - h.lastOpacityUpdate) / 1e3);

            var _iterator3 = _createForOfIteratorHelper(h.iconPerPageElementsMap),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _step3$value = _slicedToArray(_step3.value, 2),
                    _e2 = _step3$value[0],
                    _a = _step3$value[1];

                this._renderIconRange(t, S, _a, _e2, _i);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_renderIconRange",
    value: function _renderIconRange(e, t, a, i, s) {
      var n = e.context,
          o = e.spriteMosaic;
      this._spritesTextureSize[0] = o.getWidth(i) / 4, this._spritesTextureSize[1] = o.getHeight(i) / 4, t.setUniform2fv("u_mosaicSize", this._spritesTextureSize), o.bind(n, 9729, i, r), n.setStencilTestEnabled(!0), n.setStencilFunction(516, 255, 255), n.setStencilWriteMask(0), n.drawElements(4, a[1], 5125, Uint32Array.BYTES_PER_ELEMENT * a[0]), s.triangleCount += a[1] / 3;
    }
  }, {
    key: "_drawText",
    value: function _drawText(t, r, l, f) {
      var _this2 = this;

      var _p2 = t.context,
          u = t.displayLevel,
          m = t.drawPhase,
          g = t.glyphMosaic,
          y = t.painter,
          d = t.pixelRatio,
          _ = t.spriteMosaic,
          h = t.state,
          M = t.styleLayerUID,
          U = r.textMaterial,
          P = y.vectorTilesMaterialManager;
      var x,
          v = !1;

      var _iterator4 = _createForOfIteratorHelper(l),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _e3 = _step4.value;

          if (_e3.layerData.has(M) && (x = _e3.layerData.get(M), x.glyphPerPageElementsMap.size > 0)) {
            v = !0;
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (!v) return;
      var T = r.getPaintProperty("text-opacity");
      if (T && !T.isDataDriven && 0 === T.getValue(u)) return;
      var E = r.getPaintProperty("text-color"),
          D = !E || E.isDataDriven || E.getValue(u)[3] > 0,
          V = r.getPaintProperty("text-halo-width"),
          S = r.getPaintProperty("text-halo-color"),
          w = (!V || V.isDataDriven || V.getValue(u) > 0) && (!S || S.isDataDriven || S.getValue(u)[3] > 0);
      if (!D && !w) return;
      var L = 24 / 8;
      var z = r.getLayoutValue("text-rotation-alignment", u);
      2 === z && (z = 0 === r.getLayoutValue("symbol-placement", u) ? 1 : 0);
      var b = 0 === z,
          k = r.getLayoutValue("text-keep-upright", u) && b,
          I = m === n.HITTEST,
          O = .8 * L / d;
      this._glyphTextureSize || (this._glyphTextureSize = a(g.width / 4, g.height / 4));
      var R = r.getPaintValue("text-translate", u),
          j = r.getPaintValue("text-translate-anchor", u),
          A = this._sdfProgramOptions;
      A.id = I;
      var F = P.getMaterialProgram(_p2, U, A);
      _p2.useProgram(F), F.setUniformMatrix3fv("u_displayViewMat3", 0 === z ? h.displayViewMat3 : h.displayMat3), F.setUniformMatrix3fv("u_displayMat3", 1 === j ? h.displayMat3 : h.displayViewMat3), F.setUniform2fv("u_textTranslation", R), F.setUniform1f("u_depth", r.z + c), F.setUniform2fv("u_mosaicSize", this._glyphTextureSize), F.setUniform1f("u_mapRotation", o(h.rotation)), F.setUniform1f("u_keepUpright", k ? 1 : 0), F.setUniform1f("u_level", 10 * u), F.setUniform1i("u_texture", s), F.setUniform1f("u_antialiasingWidth", O), F.setUniform1f("u_fadeDuration", i / 1e3), I && F.setUniform4fv("u_id", f);
      var W = -1;

      var _iterator5 = _createForOfIteratorHelper(l),
          _step5;

      try {
        var _loop = function _loop() {
          var a = _step5.value;
          if (!a.layerData.has(M)) return "continue";
          if (a.key.level !== W && (W = a.key.level, U.setDataUniforms(F, u, r, W, _)), x = a.layerData.get(M), 0 === x.glyphPerPageElementsMap.size) return "continue";
          x.prepareForRendering(_p2), x.updateOpacityInfo();
          var t = x.textVertexArrayObject;
          if (e(t)) return "continue";
          _p2.bindVAO(t), F.setUniformMatrix3fv("u_dvsMat3", a.transforms.dvs), _p2.setStencilTestEnabled(!0), _p2.setStencilFunction(516, 255, 255), _p2.setStencilWriteMask(0);
          var i = (performance.now() - x.lastOpacityUpdate) / 1e3;
          F.setUniform1f("u_time", i), x.glyphPerPageElementsMap.forEach(function (e, t) {
            _this2._renderGlyphRange(_p2, e, t, g, F, w, D, a);
          });
        };

        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "_renderGlyphRange",
    value: function _renderGlyphRange(e, t, a, i, r, n, o, l) {
      i.bind(e, 9729, a, s), n && (r.setUniform1f("u_halo", 1), e.drawElements(4, t[1], 5125, Uint32Array.BYTES_PER_ELEMENT * t[0]), l.triangleCount += t[1] / 3), o && (r.setUniform1f("u_halo", 0), e.drawElements(4, t[1], 5125, Uint32Array.BYTES_PER_ELEMENT * t[0]), l.triangleCount += t[1] / 3);
    }
  }]);

  return p;
}(f);

export { p as WGLBrushVTLSymbol };